import { mount } from 'svelte';
import CollectionEditor from './components/CollectionEditor.svelte';

let cedit = document.getElementById('collection-editor');
if (cedit) {
    const app = mount(CollectionEditor, {
        target: cedit,
        props: {
            set: window.currentSet,
            queries: window.currentQueries,
        }
    });
}
